__turbopack_context__.v({
  "country": "HmR4WG_country",
  "country__button": "HmR4WG_country__button",
  "country__chevron": "HmR4WG_country__chevron",
  "country__flag": "HmR4WG_country__flag",
  "country__menu": "HmR4WG_country__menu",
  "country__option": "HmR4WG_country__option",
  "country__value": "HmR4WG_country__value",
  "phone": "HmR4WG_phone",
});
